import axios from 'axios'
import Screener from "./Screener"

// Wake the server up so, when posting, it'll be ready
console.log(`Pinging ${process.env.REACT_APP_SERVER_URL}`)
axios.get(process.env.REACT_APP_SERVER_URL || '/')
  .then(result => console.log(result))
  .catch(error => console.error(error))

function App() {
  return (Screener())
}

export default App;
